import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import { apiPaths } from 'app/services/api';

const ContactRequests = () => {
  const columns = [
    { name: 'Name', key: 'name' },
    { name: 'Mobile', key: 'mobile_number' },
    { name: 'City', key: 'city' },
    { name: 'Create Date', key: 'created_at', type: 'date', sort: true },
  ];

  const filtersOn = [
    { name: 'Name', key: 'name' },
    { name: 'City', key: 'city' },
    { name: 'Mobile', key: 'mobile_number' },
  ];

  return (
    <div className="m-sm-30">
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Contact Requests"
          path="contact_requests"
          apipath={apiPaths.CONTACT_REQUESTS}
          columns={columns}
          filtersOn={filtersOn}
          hideActions={['view', 'delete', 'edit', 'create']}
          // showExport
        />
      </SimpleCard>
    </div>
  );
};

export default ContactRequests;
